import React, { useState } from 'react';
import ReportContent1 from './reportcontent1'; // Import reportcontent1
import ReportContent2 from './reportcontent2'; // Import reportcontent2
import ReportContent3 from './reportcontent3'; // Add more content components as needed
import ReportContent4 from './reportcontent4'; // Add more content components as needed
import ReportSubmited from '../reportsubmited'; // Import the ReportSubmited component
import axios from 'axios';
import { api_url } from '../../constants/data';
import ReactLoading from "react-loading";
import { useNavigate } from 'react-router-dom';

function Report1() {
  const [content, setContent] = useState(1); 
  const [showStepCount, setShowStepCount] = useState(true); 
  const [form, setForm] = useState(true); 
  const [loader, setLoader] = useState(false); 
  const [emailPassword, setEmailPassword] = useState(null); 
  const token = localStorage.getItem('auth_token')
  const navigate = useNavigate()


  const _OnNext = ({data}) => {
    const fm = {...form}
    Object.keys(data).map(x => {
      fm[x] = data[x]
    })


    setForm({...fm})
    if (content === contentArray.length - 1) {
      const fd = new FormData()
      setLoader(true)
      fd.append('file', fm.selectedFiles[0])
      fd.append('where_happend', fm.abuseLocation)
      fd.append('when_happend', fm.abuseDate)
      fd.append('when_aware', fm.awarenessDate)
      fd.append('fullname', fm.personName)
      fd.append('function', fm.personFunction)
      fd.append('department', fm.personOrganization)
      fd.append('description', fm.abuseDescription)
      fd.append('type', fm.selectedAbuse)
      fd.append('share_personal_info', fm.selectAnoymouslyradio == 'Yes')
      fd.append('user_email', fm.email)

      const header = !token ? {} : {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      }

      axios.post(`${api_url}/report/store`, fd, header).then(res => {
        setEmailPassword({
          email: res.data.email,
          password: res.data.password,
        })

        if(token){
          navigate('/')
        }

        setShowStepCount(false)
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        setLoader(false)
      })
    }


    setContent((prevContent) => {
      const nextContent = prevContent + 1;
      if (nextContent === contentArray.length) {
        // setShowStepCount(false); 
      }
      return Math.min(nextContent, contentArray.length); 
    });
  };
  const _OnBack = () => {
    setContent((prevContent) => {
      const prevContentIndex = prevContent - 1;
      if (prevContentIndex < 0) {
        return 0; 
      }
      return prevContentIndex; 
    });
  };

  const handleStepClick = (step) => {
    setContent(step); 
    if (step === contentArray.length) {
      setShowStepCount(false); 
    } else {
      setShowStepCount(true); 
    }
  };

  const contentArray = [
    <ReportContent1 onNext={_OnNext} onBack={_OnBack}/>,
    <ReportContent2 onNext={_OnNext} onBack={_OnBack}/>,
    <ReportContent3 onNext={_OnNext} onBack={_OnBack}/>,
    <ReportContent4 onNext={_OnNext} onBack={_OnBack}/>,
    <ReportSubmited  email={emailPassword?.email} password={emailPassword?.password} />,
  ];

  return (
    <div className="report-content">
      {/* Conditional rendering of the header */}
      {showStepCount && (
        <div className="report-header">
          <div className="title-stepcount">
            <h1>Report Form</h1>
            <p>
              Step <span>{content}</span> of {contentArray.length - 1}
            </p>
          </div>
          <div className="stepindicator">
            {/* Render buttons excluding the last one */}
            {contentArray.slice(0, contentArray.length - 1).map((_, index) => (
              <button
                key={index}
                className={content >= index + 1 ? 'active' : ''}
                onClick={() => handleStepClick(index + 1)}
              ></button>
            ))}
          </div>
        </div>
      )}

      {!loader && (
        <div className="report-body">
          {contentArray[content - 1]} 
        </div>
      )}

      { loader && (
        <div className="report-body" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '300px' }}>
          <ReactLoading type={'spin'} color="#007dfc" />
        </div>
      ) }
    </div>
  );
}

export default Report1;
